import cn from "app/util/classnames";

interface HowToPlaySlideProps extends React.HTMLAttributes<HTMLDivElement> {
  imgContent: React.ReactNode;
  textContent: React.ReactNode;
  active: boolean;
}

export default function HowToPlaySlide(props: HowToPlaySlideProps) {
  if (props.active) {
    return (
      <div
        className={cn("flex-1 flex flex-col gap-3", {
          invisible: !props.active,
        })}
      >
        <div // IMG CONTAINER
          className="flex-none mx-auto flex justify-center"
        >
          {props.imgContent}
        </div>
        <div // TEXT CONTAINER
          className="basis-0 grow overflow-y-auto"
        >
          {props.textContent}
        </div>
      </div>
    );
  }
  return <></>;
}
